const IOS_REGEX = /iPhone|iPad|iPod/i;
const ANDROID_REGEX = /Android/i;

export enum MobileOS {
  Ios = 'ios',
  Android = 'android',
}

export function getMobileOS(): MobileOS | undefined {
  const userAgent = navigator.userAgent || navigator.vendor;

  if (IOS_REGEX.test(userAgent)) {
    return MobileOS.Ios;
  }

  if (ANDROID_REGEX.test(userAgent)) {
    return MobileOS.Android;
  }

  return undefined;
}

export function isInstalled(): boolean {
  return (
    'standalone' in navigator &&
    Boolean(navigator.standalone) &&
    window.matchMedia('(display-mode: standalone)').matches
  );
}
